"use strict";

(function () {
	angular.module('app.userlogin')
		.controller("loginController", loginController);

	loginController.$inject = ["$location", "$scope", "$timeout", "$window", "betaModalService", "focus",
		"localizationService", "loginService", "modalService", "sessionService", "utilFunctions"];

	function loginController($location, $scope, $timeout, $window, betaModalService, focus,
		localizationService, loginService, modalService, sessionService, utilFunctions) {

		var vm = this;

		var acceptBeta = false;

		vm.currentYear = null;
		vm.error = '';
		vm.isBetaVersion = null;
		vm.localStrings = null;
		vm.loginProcessing = false;
		vm.logoImgSource = null;
		vm.password = null;
		vm.saveUser = null;
		vm.scheme = null;
		vm.showError = false;
		vm.showLogin = false;
		vm.showPassword = false;
		vm.subImgSource = null;
		vm.userID = null;
		vm.useWinAuth = false;
		vm.version = null;
		vm.versionNumber = null;
		vm.winAuthEnabled = false;
		vm.winAuthObj = null;

        var init = function () {
			var date = new Date();
			vm.currentYear = date.getFullYear();
			var cadUserID = sessionService.getCadData("UserID");
            var cadModuleKey = sessionService.getCadData("ModuleKey");
			// This is an auto login request from CAD. Attempt to automatically log in the user.
			if (cadUserID != null && cadModuleKey != null) { cadAutoLogin(cadUserID, cadModuleKey); }

			loginService.requestScheme().then(initScheme);
			initLogin();

			var currentUser = $.cookie('currentValidUser') || null;
			if (currentUser != null && currentUser != "null") {
				currentUser = JSON.parse(currentUser);
				vm.userID = currentUser.UserID;
				attemptAutoLogin(currentUser);
			}
		};

		// -------------------------------------------------------------------------- Screen Controls ----------------------------------------------------------------------------- //
		vm.toggleShowPass = function () {
			vm.showPassword = !vm.showPassword;
			var passwordInput = $('#inputPass');
			passwordInput.attr("type", (vm.showPassword == false) ? "password" : "text");
		};

		vm.toggleWinAuth = function () {
			vm.userID = (vm.useWinAuth == false) ? null : vm.winAuthObj.UserID;
		};

		var showLoginError = function (err) {
			vm.error = err;
			vm.showError = true;
			vm.loginProcessing = false;
		};

		vm.getLoginLabel = function () {
			return (vm.loginProcessing == true) ? localizationService.getLocalString(2508) : localizationService.getLocalString(2509); // 'Logging in. Please Wait', 'Log in'
		};

		vm.getPasswordPlaceholder = function () {
			return (vm.useWinAuth == true) ? localizationService.getLocalString(10330) : localizationService.getLocalString(350); // 'Windows Authentication', 'Password'
		};

		vm.getLocalString = function (stringNum) {
			return localizationService.getLocalString(stringNum);
		};

		vm.getRequiredString = function (stringNum) {
			var requiredString = localizationService.getLocalString(2111); // '{0} is required'
			requiredString = requiredString.replace('{0}', localizationService.getLocalString(stringNum));
			return requiredString;
		};

		vm.forgotPass = function () {
			$location.path('/forgotPass');
		};
		// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
		// ----------------------------------------------------------------------- Screen Initialization -------------------------------------------------------------------------- //
		var initLogin = function () {
			loginService.loginInit().then(function (initReturn) {
				console.log("initReturn", initReturn);
				if (initReturn.WindowsAuthEnabled == true) {
					vm.winAuthObj = {};
					vm.winAuthObj.UserID = initReturn.UserID;
					vm.winAuthObj.ValidDbUser = initReturn.ValidDbUser;
					vm.winAuthObj.ValidDomainUser = initReturn.ValidDomainUser;
					vm.winAuthEnabled = true;
					vm.useWinAuth = true;
					vm.userID = initReturn.UserID;
				}
				showLogin();
				vm.localStrings = initReturn.LoginStrings;
				if (initReturn != null) {
					localizationService.populateLocalStringDictionary(vm.localStrings);
					sessionService.checkDatabaseVersion().then(function (version) {
						vm.version = version;
						vm.isBetaVersion = version.IsBetaVersion;
						if (version.Client === version.Database) { vm.versionNumber = "v" + version.Client; }
						else {
							var modalDefaults = {
								backdrop: 'static',
								keyboard: false,
								modalFade: false,
								scope: $scope,
								windowClass: 'asa-msg-modal',
								templateUrl: 'shared/modals/asaVersionErrorModal.html'
							};

							var modalOptions = {
								modalType: 1,
								messageClass: 'danger',
								ErrorText: localizationService.getLocalString(4390), // 'Client and Database versions do not match.'
								Client: version.Client,
								Database: version.Database,
								ContactText: localizationService.getLocalString(2742), //  'Contact your system administrator.'
								headerText: 'Error'
							};

							modalService.showModal(modalDefaults, modalOptions).then(function (result) {
								if (result === 'ok') { return; }
							});
						}
					});
				}
			});
		};

		var initScheme = function (scheme) {
			vm.scheme = scheme;
			if (vm.scheme != null) {
				vm.schemeStyle = '{\'height\': \'100vh\',' +
					'\'background-color\': \'' + vm.scheme.BackgroundColor + '\',' +
					'\'color\': \'' + vm.scheme.FontColor + '\',' +
					'\'box-shadow\': \'inset 0px 0px 2px 2px whitesmoke\'}';
				if (vm.scheme.LogoImage !== null) { vm.logoImgSource = "data:image/jpeg;base64," + vm.scheme.LogoImage; }
				if (vm.scheme.SubImage !== null) { vm.subImgSource = "data:image/jpeg;base64," + vm.scheme.SubImage; }
			}
		};

		var showLogin = function () {
			vm.showLogin = true;
			if (vm.winAuthEnabled == false) {
				vm.userID = $.cookie('savedUser') || null;
				if (vm.userID !== null) {
					vm.saveUser = true;
					$timeout(function () { focus('inputPass'); }, 100);
				}
				else { $timeout(function () { focus('UserID'); }, 100); }
			}
		};
		// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
		// -------------------------------------------------------------------------- Auto Login Code ----------------------------------------------------------------------------- //
		var attemptAutoLogin = function (currentUser) {
			console.log("attemptAutoLogin");
			sessionService.autoLogin(vm.userID).then(function (autoLoginReturn) {
				console.log("autoLoginReturn", autoLoginReturn);
				if (autoLoginReturn != null) {
					var person = autoLoginReturn.Person;
					var loc = localStorage.getItem("locations");

					if (loc == null || loc.length == 0) {
						showLoginError(localizationService.getLocalString(2511)); // 'Error loading Locations, please try to Login again.'
						return;
					}

					var parsedLocs = JSON.parse(loc);
					var erpkey;
					var companyKey;

					for (var i = 0; i < parsedLocs.length; i++) {
						if (parsedLocs[i].LocKey === person.Users[0].PrimaryLocKey) {
							erpkey = parsedLocs[i].ERPKey;
							companyKey = parsedLocs[i].CompanyKey;
							break;
						}
					}
					var lockey = person.Users[0].PrimaryLocKey;
					var moduleKey = person.Users[0].DfltModuleKey;

					sessionService.setCredentials(currentUser.PersonKey, currentUser.UserID, autoLoginReturn.DfltLangID, currentUser.authdata, moduleKey, lockey, companyKey, erpkey, currentUser.UserName, parsedLocs, false, false, vm.saveUser, person.Users[0].PrimaryLocKey, person.PersonImage, vm.useWinAuth, autoLoginReturn.HostName);

					var routeUrl = null;
					if (sessionStorage.getItem('tempPath') !== null) {
						routeUrl = sessionStorage.getItem('tempPath');
						sessionStorage.removeItem('tempPath');
					}
					else { routeUrl = autoLoginReturn.DfltLoginUrl; }

					$window.location.assign(routeUrl);
				}
			});
		};

		var cadAutoLogin = function (cadUserID, cadModuleKey) {
            sessionService.cadAutoLogin(cadUserID, cadModuleKey).then(function (autoLoginReturn) {
				if (autoLoginReturn != null) {
					var person = autoLoginReturn.Person;
					var username = person.FirstName + " " + person.LastName;
					locKey = person.Users[0].PrimaryLocKey;
					for (var i = 0; i < autoLoginReturn.Locations.length; i++) {
						if (autoLoginReturn.Locations[i].LocKey === locKey) {
							erpKey = autoLoginReturn.Locations[i].ERPKey;
							companyKey = autoLoginReturn.Locations[i].CompanyKey;
							break;
						}
					}
					sessionService.setCredentials(person.PersonKey, person.PersonID, autoLoginReturn.DfltLangID, autoLoginReturn.SessionToken, cadModuleKey, locKey, companyKey, erpKey, username, autoLoginReturn.Locations, false, false, false, locKey, person.PersonImage, vm.useWinAuth, autoLoginReturn.HostName);

					console.log("CAD AUTO LOGIN");
					var cadUrl = autoLoginReturn.DfltLoginUrl;
					var cadOpenID = sessionService.getCadData("OpenID");
					var cadOpenKey = sessionService.getCadData("OpenKey");
                    var cadTranKey = sessionService.getCadData("TransmittalKey");
                    var cadWebPageKey = sessionService.getCadData("WebPage");

					if (cadOpenID != null) { cadUrl = cadUrl + "/#/?openID=" + cadOpenID; }
                    else if (cadOpenKey != null) { cadUrl = cadUrl + "/#/?openKey=" + cadOpenKey; }
                    
					else if (null != cadWebPageKey)
					{
						if (1 == cadWebPageKey) { cadUrl = cadUrl + "/#/drawingTransmittalLetter"; }
						else if (2 == cadWebPageKey) { cadUrl = cadUrl + "/#/drawingTransmittalLog"; }
						else if (3 == cadWebPageKey) { cadUrl = cadUrl + "/#/tieDesigner"; }
						else if (4 == cadWebPageKey) { cadUrl = cadUrl + "/#/shapeDesigner"; }
						else if (5 == cadWebPageKey) { cadUrl = cadUrl + "/#/reserveCC"; }
						else if (6 == cadWebPageKey) { cadUrl = "environment/environmentsetup/#/seqMacro"; }
						else if (7 == cadWebPageKey) { cadUrl = "inventory/inventorysetup/#/productClassMain"; }
						else if (8 == cadWebPageKey) { cadUrl = "inventory/inventorysetup/#/productMain"; }
						else if (9 == cadWebPageKey) { cadUrl = "environment/environmentsetup/#/main"; }
					}

					else if (null != cadTranKey) { cadUrl = cadUrl + "/#/reports/?cadReportKey=" + cadTranKey; }

					console.log('cadURL = ' + cadUrl);
					$window.location.assign(cadUrl);
				}
			});
		};
		// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
		// -------------------------------------------------------------------------- Core Login Code ----------------------------------------------------------------------------- //
		vm.login = function () {
			if (vm.version.Client !== vm.version.Database) { return; }
			vm.showError = false;
			var regexObj = /^[a-zA-Z0-9_@.-]*$/;
			if (regexObj.test(vm.userID)) { 
				vm.loginProcessing = true;
				loginService.loginUser(vm.userID, vm.password, acceptBeta, vm.useWinAuth).then(onCheckSuccess, onCheckError);
			}
			else { showLoginError(localizationService.getLocalString(2513)); } // 'Invalid user ID or password'
		};

		var onCheckSuccess = function (data) {
			console.log("Login Return", data);
			if (data !== null) {
				var user = data;
				if (data.ValidLogin == true && data.IsLicensed == true) {
					if (data.ErrorCode.indexOf("GRACE-") > -1) {
						var dayIdx = data.ErrorCode.indexOf("-");
						var daysLeft = data.ErrorCode.slice(dayIdx + 1);
						var graceErrorString = localizationService.getLocalString(2512); // 'You have {0} day(s) until your license expires.'
						graceErrorString = graceErrorString.replace('{0}', daysLeft.toString());

						var modalOptions = {
							modalType: 1,
							messageClass: 'warning',
							okButtonText: localizationService.getLocalString(16), // 'OK'
							bodyText: graceErrorString
						};
						modalService.showModal({}, modalOptions).then(function (result) {
							if (result === 'ok') { finalizeLogin(data, user); }
						});
					}
					else if (data.ErrorCode.indexOf("BETA") > -1 && acceptBeta == false) {
						var settings = {
							scope: $scope,
							userID: user.UserID
						};
						betaModalService.showModal({}, settings).then(function (result) {
							if (result === true) {
								acceptBeta = true;
								vm.login();
							}
							else { vm.loginProcessing = false; }
						});
					}
					else { finalizeLogin(data, user); }
				}
				else {
					if (data.ValidLogin == false) {
						if (data.InvalidDomainUser == true) {
							showLoginError(localizationService.getLocalString(10331)); // 'The domain account is not associated to a Studio User.'
						}
						else if (data.InvalidDbUser == true) {
							showLoginError(localizationService.getLocalString(10332)); // 'The domain account does not have access to the SQL database.'
						}
						else if (data.ValidLocation == false) {
							showLoginError(localizationService.getLocalString(10711)); // 'Your default login location is set to inactive.'
						}
						else if (data.ValidUser == false) {
							showLoginError(localizationService.getLocalString(13076)); // 'Your user account is set to inactive.'
						}
						else {
							showLoginError(localizationService.getLocalString(2513)); // 'Invalid user ID or password'
						}
					}
					else if (data.IsLicensed == false) { showLicenseError(data); }
				}
			}
			else { showLoginError(localizationService.getLocalString(2513)); } // 'Invalid user ID or password'
		};

		var finalizeLogin = function (loginReturn, user) {
			//MAKE SURE THESE DIDN'T GET WIPED OUT!
			if (loginReturn.Locations === null) {
				showLoginError(localizationService.getLocalString(2511)); // 'Error loading Locations, please try to Login again.'
				return;
			}

			var locKey = user.PrimaryLocKey;
			var erpKey;
			var companyKey;
			for (var i = 0; i < loginReturn.Locations.length; i++) {
				if (loginReturn.Locations[i].LocKey === locKey) {
					erpkey = loginReturn.Locations[i].ERPKey;
					companyKey = loginReturn.Locations[i].CompanyKey;
					break;
				}
			}

			var username = loginReturn.FirstName + ' ' + loginReturn.LastName;
			console.log("log in data...", loginReturn);
			sessionService.setCredentials(user.PersonKey, vm.userID, loginReturn.DfltLangID, user.SessionToken, loginReturn.DfltModuleKey, locKey, companyKey, erpkey, username, loginReturn.Locations, false, true, vm.saveUser, loginReturn.PrimaryLocKey, user.PersonImage, vm.useWinAuth, loginReturn.HostName);
			$scope.UserName = username;

			$window.location.assign(user.DfltLoginUrl);
		};

		var onCheckError = function (loginError) {
			console.log("Login Error:", loginError);
			showLoginError(localizationService.getLocalString(5905)); // 'Error logging in user'
		};

		var showLicenseError = function (loginReturn) {
			vm.loginProcessing = false;

			var modalDefaults = {
				backdrop: 'static',
				keyboard: false,
				modalFade: false,
				scope: $scope,
				windowClass: 'asa-msg-modal',
				templateUrl: 'shared/modals/asaLicenseErrorModal.html'
			};

			if (loginReturn.ErrorCode.toLowerCase() === "locerror") {
				var bodyString = localizationService.getLocalString(2500); // 'Your location {0} is not licensed or is on hold.'
				var loc = utilFunctions.findByProperty(loginReturn.Locations, 'LocKey', loginReturn.PrimaryLocKey);
				if (loc !== null) {
					var locString = loc.LocID + " – " + loc.LocName;
					bodyString = bodyString.replace('{0}', locString);
				}
				else { bodyString = bodyString.replace('{0}', ''); }

				var modalOptions = {
					modalType: 1,
					messageClass: 'danger',
					okButtonText: localizationService.getLocalString(16), // 'OK'
					ErrorText: null,
					BodyText: bodyString,
					ContactText: localizationService.getLocalString(2502), // 'Please contact your local system administrator.'
					headerText: localizationService.getLocalString(2505) // 'License Error'
				};
			}
			else if (loginReturn.ErrorCode.toLowerCase() == "usererror") {
				var modalOptions = {
					modalType: 1,
					messageClass: 'danger',
					okButtonText: localizationService.getLocalString(16), // 'OK'
					ErrorText: null,
					BodyText: localizationService.getLocalString(2499), // 'You have reached the maximum number of logged in users.'
					ContactText: localizationService.getLocalString(2498), //  'Please contact our sales team to purchase more licenses.'
					headerText: localizationService.getLocalString(2505) // 'License Error'
				};
			}
			else if (loginReturn.ErrorCode.toLowerCase() == "licexpire") {
				var modalOptions = {
					modalType: 1,
					messageClass: 'danger',
					okButtonText: localizationService.getLocalString(16), // 'OK'
					ErrorText: null,
					BodyText: localizationService.getLocalString(7968), // 'Your license has expired.'
					ContactText: localizationService.getLocalString(8180), //  'Please contact aSa for support.'
					headerText: localizationService.getLocalString(2505) // 'License Error'
				};
			}
			else {
				var errorMessage = localizationService.getLocalString(2501) + " " + loginReturn.ErrorCode;
				var modalOptions = {
					modalType: 1,
					messageClass: 'danger',
					okButtonText: localizationService.getLocalString(16), // 'OK'
					ErrorText: errorMessage,
					BodyText: localizationService.getLocalString(2503), // 'We have detected an issue with your License.'
					ContactText: localizationService.getLocalString(2504), // 'Please contact aSa, +1.724.733.8700.'
					headerText: localizationService.getLocalString(2505) // 'License Error'
				};
			}

			modalService.showModal(modalDefaults, modalOptions).then(function (result) {
				if (result === 'ok') { return; }
			});
		};
		// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
		init();
	}
}());